import classes from "./ScrollToTop.module.less";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

export const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onScroll = () => {
    const scrolled = window.scrollY;
    const windowHeight = window.innerHeight;
    scrolled > windowHeight ? setShowButton(true) : setShowButton(false);
  };

  const cls = classNames(classes.button, showButton ? classes.buttonShow : classes.buttonHide);

  return (
    <div className={cls} onClick={() => window.scroll(0, 0)}>
      <Icon type={IconType.ChevronUp} />
    </div>
  );
};
